import React, {Component} from 'react'
import PropTypes from 'prop-types';
import {Link} from "react-router-dom";
import Img from 'react-image'

class PartnersCardItem extends Component {

    render(){

        const {src, title, link, width} = this.props
        return (
            <Link to={link} className={`col-${width} entertainment-card-item partner-card`}>
                    <Img src={src} alt={title}/>
            </Link>
        )
    }
}
PartnersCardItem.propType = {
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
}

export default PartnersCardItem


// WEBPACK FOOTER //
// ./src/components/partners-card.js